(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('exposure-type', {
            parent: 'entity',
            params:{screen:'ExposureType'},
            url: '/exposure-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.exposureType.title" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/exposure-type/exposure-type.html',
                    controller: 'ExposureTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
	           	validateSODAndSession: ['ExposureType', function(ExposureType, GlobalValues) {
	                return ExposureType.validateSODAndSession().$promise;
	            }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exposureType');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
       
        .state('exposure-type-new', {
            parent: 'exposure-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	                           	
                             
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-type-edit', {
            parent: 'exposure-type',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	 entity: ['ExposureType', 'GlobalValues', function(ExposureType, GlobalValues) {
                             return ExposureType.get({id : $stateParams.id}).$promise;
                         }],
                         mode: function(){
                         	return ""
                         }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-type-view', {
            parent: 'exposure-type',
            url: '/view/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	 entity: ['ExposureType', 'GlobalValues', function(ExposureType, GlobalValues) {
                             return ExposureType.get({id : $stateParams.id}).$promise;
                         }],
                         mode: function(){
                         	return "VIEW"
                         }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-type-todolist', {
            parent: 'dashboard',
            url: '/exposureType',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                	$state.go('exposure-type', null, { reload: 'exposure-type' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('exposure-type-todolist-resubmit', {
            parent: 'dashboard',
            url: '/exposureTypeEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
	                      entity: function () {                       	
	                          
	                      },
	                      mode: function(){
	                      	return ""
	                      }
                    }
                }).result.then(function() {
                	$state.go('exposure-type', null, { reload: 'exposure-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('exposure-type-auditLog', {
            parent: 'audit-log',
            url: '/exposureTypeAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                	$state.go('exposure-type', null, { reload: 'exposure-type' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('exposure-type-historyReport', {
            parent: 'history-report',
            url: '/exposureTypeHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exposure-type/exposure-type-dialog.html',
                    controller: 'ExposureTypeEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        },
                        mode: function(){
                        	return ""
                        }
                    }
                }).result.then(function() {
                	$state.go('exposure-type', null, { reload: 'exposure-type' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();
